import React from 'react';

import { useSelector } from 'react-redux';

import { isPast, secondsToMilliseconds } from 'date-fns';

import { selectLayoutConfig } from 'store/config/selectors';
import { SearchProgram } from 'store/railsBuilder/reducer.types';

import ContentMarkerIcons from 'components/ContentMarkerIcons';
import Marker from 'components/Marker';
import gRibbonItemStyles from 'components/Ribbon/RibonItem/styles';
import useSearchParentalRating from 'components/Ribbon/hooks/useSearchParentalRating';

type Props = {
    searchItem: SearchProgram;
    isLive: boolean;
};

const SearchProgramMarkers = ({ searchItem, isLive }: Props) => {
    const { primary } = useSelector(selectLayoutConfig);

    const { type } = searchItem;

    const ableToPlayCatchup = !!(
        !isLive &&
        searchItem.end &&
        isPast(secondsToMilliseconds(searchItem.end))
    );

    const parentalRating = useSearchParentalRating(searchItem);

    return (
        <>
            {searchItem.start && searchItem.end && (
                <Marker
                    startTime={searchItem.start}
                    endTime={searchItem.end}
                    bgColor={primary}
                    style={[
                        gRibbonItemStyles.marker,
                        {
                            bottom: isLive ? 20 : 8,
                        },
                    ]}
                    textStyle={gRibbonItemStyles.markerText}
                    type={type}
                />
            )}

            <ContentMarkerIcons
                isLimitedToOne
                shouldDisplayCatchup={ableToPlayCatchup}
                isOnLiveCard={isLive}
                parentalRating={parentalRating}
            />
        </>
    );
};

export default SearchProgramMarkers;
